/* eslint-disable  @typescript-eslint/restrict-template-expressions */

import { useEffect, useState } from 'react'
import { Body } from '../../../Layouts/Body'
import { MetaButton } from '../../../../components/Buttons/MetaButton'
import { ModalDelete } from '../../../../components/ModalDelete'
import { SectionHeader } from '../Components/SectionHeader'
import { IDepartment } from '../../../../interfaces'
import { appApi } from '../../../../services/appApi'
import { Flex } from '../../../../styles/styledGlobal'
import { NavBar } from '../Components/NavBar'
import { CreateDepartmentModal } from './Components/CreateDepartmentModal'
import { DepartmentCard } from './Components/DepartmentCard'
import { UpdateDepartmentModal } from './Components/UpdateDepartmentModal'
import { Main } from './styles'
import { parseJwt } from '../../../../services/token'
import { useAuth } from '../../../../contexts/AuthContext'

interface INavLink {
  to: string
  linkTitle: string
  exact?: boolean
}

export const DepartamentoDesenvolvimento: React.FC = () => {
  const { permitirFuncao } = useAuth()
  function ObterRotas(): INavLink[] {
    const rotas: INavLink[] = []
    if (parseJwt().adm === 'True' || permitirFuncao('Organograma', 'visao-geral')) {
      rotas.push({
        to: '/Organograma/Dashboard',
        linkTitle: 'Visão geral'
      })
    }

    if (parseJwt().adm === 'True' || permitirFuncao('Organograma', 'areas')) {
      rotas.push({
        to: '/Organograma/Departamentos',
        linkTitle: 'Áreas'
      })
    }

    if (parseJwt().adm === 'True' || permitirFuncao('Organograma', 'funcoes')) {
      rotas.push({
        to: '/Organograma/Cargos',
        linkTitle: 'Funções'
      })
    }

    if (parseJwt().adm === 'True' || permitirFuncao('Organograma', 'colaboradores')) {
      rotas.push({
        to: '/Organograma/Colaboradores',
        linkTitle: 'Colaboradores'
      })
    }
    return rotas
  }
  const [Departamentos, setDepartamentos] = useState<IDepartment[]>([])
  const [EditDepart, setEditDepart] = useState<IDepartment>({
    id: '',
    nome: ''
  })

  const [ModalCreateIsOpen, setModalCreateIsOpen] = useState(false)
  const [ModalUpdateIsOPen, setModalUpdateIsOPen] = useState(false)
  const [ModalDeleteIsOpen, setModalDeleteIsOpen] = useState(false)

  function GetDepartamentos(): void {
    appApi.get('Departamento').then(res => setDepartamentos(res.data)).catch(err => console.log(err))
  }

  function onCreateDepartamentos(obj: IDepartment): void {
    const form: Omit<IDepartment, 'id'> = {
      nome: obj.nome,
      departamentoPaiId: obj.departamentoPaiId
    }

    appApi.post('Departamento', form).then(() => {
      GetDepartamentos()
      onRequestModalCreateClose()
    }).catch(err => console.log(err))
  }

  function onDeleteDepartamento(): void {
    appApi.delete(`Departamento/${EditDepart.id}`).then(GetDepartamentos).catch(err => console.log(err))
  }

  function onUpdateDepartamento(obj: IDepartment): void {
    const form: Omit<IDepartment, 'id'> = {
      nome: obj.nome,
      departamentoPaiId: obj.departamentoPaiId
    }

    appApi.put(`Departamento/${obj.id}`, form).then(res => {
      GetDepartamentos()
      onRequestModalUpdateClose()
    }).catch(err => console.log(err))
  }

  function onRequestModalCreateClose(): void {
    setModalCreateIsOpen(false)
  }

  function onRequestModalUpdateClose(): void {
    setModalUpdateIsOPen(false)
  }

  function onRequestModalDeleteClose(): void {
    setModalDeleteIsOpen(false)
    setEditDepart({
      id: '',
      nome: ''
    })
  }

  function onOpenModalDelete(obj: IDepartment): void {
    setModalDeleteIsOpen(true)
    setEditDepart(obj)
  }

  function onOpenModalUpdate(obj: IDepartment): void {
    setModalUpdateIsOPen(true)
    setEditDepart(obj)
  }

  useEffect(() => {
    GetDepartamentos()
  }, [])

  return (
    <Body>
      <Main>
        <CreateDepartmentModal
          isOpen={ModalCreateIsOpen}
          departmentList={Departamentos}
          onCreateDepartment={onCreateDepartamentos}
          onRequestClose={onRequestModalCreateClose}
        />

        <UpdateDepartmentModal
          isOpen={ModalUpdateIsOPen}
          departmentList={Departamentos}
          onUpdateDepartment={onUpdateDepartamento}
          onRequestClose={onRequestModalUpdateClose}
          initialData={EditDepart}
        />

        <ModalDelete
          isOpen={ModalDeleteIsOpen}
          onRequestClose={onRequestModalDeleteClose}
          onConfirm={onDeleteDepartamento}
          message={'Deseja realmente excluir esta área?'}
        />

        <NavBar
          title="Organograma"
          navLinks={ObterRotas()}
        />
        <Flex style={{ justifyContent: 'end' }}>
          <MetaButton onClick={() => setModalCreateIsOpen(true)} bg='v2' size='md' styles={{ margin: '1rem 0rem' }}>Nova área</MetaButton>
        </Flex>

        <SectionHeader title="Áreas" />
        <section>
          {
            Departamentos.map((e: IDepartment, i) => {
              return (
                <DepartmentCard
                  key={i}
                  department={e}
                  onEdit={() => onOpenModalUpdate(e)}
                  onDelete={() => onOpenModalDelete(e)}
                />
              )
            })
          }
        </section>
      </Main>
    </Body>
  )
}
